(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3761],{

/***/ 97987:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[company]/settings/general",
      function () {
        return __webpack_require__(81300);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7165,5675,1664,6657,4321,4894,8972,1300,9774,2888,179], function() { return __webpack_exec__(97987); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);